var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('forms',{attrs:{"settings":_vm.settings},on:{"onFormButtonClick":_vm.onFormButtonClick,"onInput":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }